import React, { useRef } from "react";
import "./IllustCard.scoped.scss";
import img_wire from "../../img/illusts/wire.png";

export enum BackGroundType {
  Img0,
  Img1,
  Img2,
  Img3,
  Img4,
  Max,
}

export interface CardInfo {
  readonly name: string;
  readonly twitterID: string;
  readonly src: string;
  readonly backgroundType: BackGroundType;
}

interface Props extends CardInfo {
  readonly open: (info: CardInfo) => void;
}

// 1枚分のメッセージカードを表現するコンポーネント
export default function IllustCard(props: Props) {
  const thumbnailFile = props.src
    .replace(".png", ".jpg")
    .replace(".jpeg", ".jpg")
    .replace(".JPG", ".jpg");
  const src = `${process.env.PUBLIC_URL}/img/illusts/thumbnail/${thumbnailFile}`;
  const card = useRef<HTMLDivElement>(null);
  const anim = new SwayAnim(card, 1.0);

  return (
    <div className="group relative">
      <div className="wire">
        <img src={img_wire} alt="wire"></img>
      </div>
      <div
        className={`card_type${props.backgroundType}`}
        ref={card}
        onMouseMove={(event) => {
          if (anim.tryLock()) {
            anim.raiseHover(event.movementX);
          }
        }}
        onMouseLeave={() => anim.unlock()}
      >
        <div className="illust">
          <img
            src={src}
            alt={`Illustration by ${props.name} (@${props.twitterID})`}
            loading="lazy"
            onClick={() => {
              anim.raiseHover(0);
              props.open(props);
            }}
          ></img>
        </div>
        <div className="author">
          <div className="author-center">
            {props.name}
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://twitter.com/${props.twitterID}`}
              className="App-link"
            >
              {`@${props.twitterID}`}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

// マウスホバーで揺らすアニメーション
// transitionだと複雑な動きができないし、Keyframeだと再度マウスが載ったときにアニメーションがリセットされるので丁寧にやりたかった。
class SwayAnim {
  private interval_id: NodeJS.Timeout | null = null;
  private totalTime = 0;
  private locked = false;

  constructor(
    private readonly card: React.RefObject<HTMLDivElement>,
    private readonly duration: number
  ) {}

  public raiseHover(movementX: number) {
    if (this.interval_id) {
      return;
    }

    const sign = movementX >= 0 ? -1 : +1;
    this.totalTime = 0.0;

    const interval_ms = 16;
    this.interval_id = setInterval(() => {
      this.totalTime += interval_ms / 1000.0;

      if (this.totalTime >= this.duration) {
        this.totalTime = this.duration;
        if (this.interval_id) {
          clearInterval(this.interval_id);
          this.interval_id = null;
        }
      }

      // 最後に設定
      if (this.card.current) {
        const amount = this.totalTime / this.duration;
        const coef = 1.0 - Math.sqrt(amount);
        const deg = Math.sin(amount * Math.PI * sign * 4) * 10 * coef;

        const style = this.card.current.style;
        style.transformOrigin = "50% 5%";
        style.transform = `rotate(${deg}deg)`;
      }
    }, interval_ms);
  }

  // マウスの移動量を見たいので初回mouseMoveを判別できるようにLock機構を入れる。
  public tryLock() {
    if (!this.locked) {
      this.locked = true;
      return true;
    }
    return false;
  }
  // mouseLeaveしたらリセット
  public unlock() {
    this.locked = false;
  }
}
